import {
  responseDataFormat,
  handleCatchErrors,
  responseDataFormatRedux,
} from "../../middlewares/resolveRequests";
import {
  addAttachment,
  addSubTask,
  addTask,
  delSubTask,
  delSubTaskProc,
  delTask,
  getAllTasks,
  getEditTaskForm,
  getSubTask,
  getSubTaskAdd,
  getSubTaskAttachments,
  getSubTaskEdit,
  getSubTasks,
  getTask,
  getTaskAttachments,
  getTaskForm,
  getTaskMembers,
  getTaskSearchForm,
  getTaskStatus,
  searchTasks,
  searchTaskStatusCount,
  setStatus,
  updateSubTask,
  updateTask,
} from "../../services/tasks";
import * as actionTypes from "../actions/actionTypes";
import { setTasksStatus } from "./../../services/tasks";

export const editTaskForm = async (data, token) => {
  let response;
  try {
    response = await updateTask(data, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const addTaskForm = async (data, token) => {
  let response;
  try {
    response = await addTask(data, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const addAttachmentForm = async (
  taskId,
  procedureId,
  activityId,
  activityProcId,
  projectId,
  subTaskId,
  subProcedureId,
  data,
  token,
) => {
  let response;
  try {
    if (taskId != null)
      response = await addAttachment(
        taskId,
        null,
        null,
        null,
        null,
        null,
        null,
        data,
        token,
      );
    else if (activityId != null)
      response = await addAttachment(
        null,
        null,
        activityId,
        null,
        null,
        null,
        null,
        data,
        token,
      );
    else if (activityProcId != null)
      response = await addAttachment(
        null,
        null,
        null,
        activityProcId,
        null,
        null,
        null,
        data,
        token,
      );
    else if (projectId != null)
      response = await addAttachment(
        null,
        null,
        null,
        null,
        projectId,
        null,
        null,
        data,
        token,
      );
    else if (subTaskId != null)
      response = await addAttachment(
        null,
        null,
        null,
        null,
        null,
        subTaskId,
        null,
        data,
        token,
      );
    else if (subProcedureId != null)
      response = await addAttachment(
        null,
        null,
        null,
        null,
        null,
        null,
        subProcedureId,
        data,
        token,
      );
    else
      response = await addAttachment(
        null,
        procedureId,
        null,
        null,
        null,
        null,
        null,
        data,
        token,
      );
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const getCommunityTaskForm = async (communityId, token) => {
  let response;
  try {
    response = await getTaskForm(communityId, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormatRedux(response, actionTypes.GET_COMMUNITY_FORM);
  }
};

export const getTaskSearch = async (communityId, token) => {
  let response;
  try {
    response = await getTaskSearchForm(communityId, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const getEditDataTaskForm = async (taskId, communityId, token) => {
  if (taskId) {
    let response;
    try {
      response = await getEditTaskForm(taskId, communityId, token);
      // setVisible(true);
    } catch (e) {
      response = handleCatchErrors(e);
    } finally {
      return responseDataFormat(response);
    }
  }
};

export const getAllTasksWithProcedures = async (
  communityId,
  userId,
  pageNumber = 1,
  pageSize = 20,
  token,
) => {
  let response;
  try {
    response = await getAllTasks(
      communityId,
      userId,
      pageNumber,
      pageSize,
      token,
    );
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormatRedux(
      response,
      actionTypes.GET_TASKS_WITH_PROCEDURES,
    );
  }
};

export const searchAllTasks = async (
  communityID,
  pageNumber = 1,
  pageSize = 20,
  data = {},
  token,
) => {
  let response;
  try {
    response = await searchTasks(
      communityID,
      pageNumber,
      pageSize,
      data,
      token,
    );
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormatRedux(
      response,
      actionTypes.GET_TASKS_WITH_PROCEDURES,
    );
  }
};

export const searchAllTaskStatusCount = async (
  communityID,
  data = {},
  token,
) => {
  let response;
  try {
    response = await searchTaskStatusCount(communityID, data, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormatRedux(response, actionTypes.GET_TASKS_COUNT);
  }
};

export async function getTaskDetails(taskId, token) {
  let response;
  try {
    response = await getTask(taskId, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormatRedux(response, actionTypes.GET_TASK_DETAILS);
  }
}
export async function getSubTasksDetails(taskId, token) {
  let response;
  try {
    response = await getSubTasks(taskId, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormatRedux(response, actionTypes.GET_SUB_TASK_DETAILS);
  }
}

export async function getSubTaskDetails(subTaskId, token) {
  let response;
  try {
    response = await getSubTask(subTaskId, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
}

export function clearTaskDetails() {
  let status = 200;
  let response = {
    data: status >= 200 && status <= 206 ? true : false,
  };
  return responseDataFormatRedux(response, actionTypes.GET_TASK_DETAILS);
}

export function searchKey(searchkey) {
  let status = 200;
  let response = {
    data: status >= 200 && status <= 206 ? searchkey : null,
  };
  return responseDataFormatRedux(response, actionTypes.SEARCHKEY);
}

export function clearSearchKeys() {
  let response = {
    data: null,
  };
  return responseDataFormatRedux(response, actionTypes.SEARCHKEY);
}

export const getAllTaskMembers = async (taskId, token) => {
  let response;
  try {
    response = await getTaskMembers(taskId, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const getAllTaskAttachments = async (
  taskId,
  pageNo = 1,
  pageCount = 10,
  token,
) => {
  let response;
  try {
    response = await getTaskAttachments(taskId, pageNo, pageCount, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormatRedux(
      response,
      actionTypes.GET_ALL_TASK_ATTACHMENTS,
    );
  }
};

export const getAllSubTaskAttachments = async (
  subTaskId,
  pageNo = 1,
  pageCount = 10,
  token,
) => {
  let response;
  try {
    response = await getSubTaskAttachments(subTaskId, pageNo, pageCount, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormatRedux(
      response,
      actionTypes.GET_ALL_SUB_TASK_ATTACHMENTS,
    );
  }
};

// export const sortByStatus = async (data) => {
//   let response = {
//     data: data.sort((item) => {
//       return item.taskStatus.id;
//     }),
//   };
//   return responseDataFormatRedux(
//     response,
//     actionTypes.GET_TASKS_WITH_PROCEDURES
//   );
// };

export const getAllTaskStatus = async (token) => {
  let response;
  try {
    response = await getTaskStatus(token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const setMemberStatus = async (memberId, statusId, token) => {
  let response;
  try {
    response = await setStatus(memberId, statusId, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
  }
};

export const setTaskStatus = async (
  taskId,
  cahngeAll,
  statusId,
  resolver,
  request,
  store,
  token,
) => {
  if (statusId) {
    let response;
    try {
      response = await setTasksStatus(taskId, statusId, cahngeAll, token);
      if (cahngeAll) {
        store(null);
        resolver(request, store, taskId, token);
      }
    } catch (e) {
      response = handleCatchErrors(e);
    }
  }
};

export const deleteTask = async (taskId, token) => {
  let response;
  try {
    response = await delTask(taskId, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

//subTasks
export const deleteSubTask = async (subTaskID, token) => {
  let response;
  try {
    response = await delSubTask(subTaskID, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const deleteSubTaskProc = async (subTaskID, token) => {
  let response;
  try {
    response = await delSubTaskProc(subTaskID, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const editSubTaskData = async (subTaskId, communityId, token) => {
  let response;
  try {
    response = await getSubTaskEdit(subTaskId, communityId, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const editSubTaskForm = async (data, communityId, token) => {
  let response;
  try {
    response = await updateSubTask(data, communityId, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const SubTaskDataAdd = async (communityId, token) => {
  let response;
  try {
    response = await getSubTaskAdd(communityId, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormatRedux(response, actionTypes.GET_SUB_TASK_FORM);
  }
};

export const addSubTaskForm = async (data, token) => {
  let response;
  try {
    response = await addSubTask(data, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};
